module.exports = ({React,connect,Modal,Router,LuluActions,FormGroup,NumberFormat,Spinner})->


  class LuluModal extends React.Component
    
    constructor:(props)->
      super(props)
      @state = {preview:false}

    componentDidMount:->
      if(@props.match.params.lulu_id != "new")
        @props.dispatch(LuluActions.lulusAreEditing(true)) # need to set editing to true here and load org data
        @props.dispatch(LuluActions.lulusLoadSelected("/duocms/api/lulu/"+@props.match.params.lulu_id))
      else
        @props.dispatch(LuluActions.lulusAdding(true))
        @props.dispatch(LuluActions.lulusAreSelected({}))

    componentDidUpdate:(prev_props)->
      if @props.luluSavedSuccess != prev_props.luluSavedSuccess
        @close() # closes after saving

    close:-> 
      @props.history.push("/ecommerce/lulu") 

    parentPath:->
      # @getPathname().replace(/\/[^\/]*\/[^\/]*$/,'')

    save:->
      @props.dispatch(LuluActions.lulusSaveSelected(@props.lulusSelected[0],"Lulu saved successfully"))

    update:(id,field,value)->
      @props.dispatch(LuluActions.lulusSelectedUpdated(id,field,value))

    currency_symbol:(currency)->
      symbols = {"GBP":"£","EUR":"€","USD":"$"}
      return if currency && symbols[currency] then symbols[currency] else "£"

    render: ->
      return <span /> if !@props.lulusSelected[0]
      {shipping_address,status,costs,line_items,id} = @props.lulusSelected[0]
      #Clip id, qualification, level, grade, topic  
      <Modal title={@props.lulusSelected[0]?.subject || "Lulu Job Details"} onclose={(e)=> @close()} className="modal-lg">
        {if status && costs && line_items && shipping_address
          <form className="form-horizontal">
            <div className="row">
              <div className="col-sm-6">
                <FormGroup type="static" labelwidth="col-xs-6" inputwidth="col-xs-4" label="Job Id"><p className="form-control-static">{id}</p></FormGroup>
                <FormGroup type="static" labelwidth="col-xs-6" inputwidth="col-xs-4" label="Status"><p className="form-control-static">{status.name}</p></FormGroup>
                <FormGroup type="static" labelwidth="col-xs-6" inputwidth="col-xs-4" label="Total Cost (inc tax)"><p className="form-control-static">{costs.total_cost_incl_tax}</p></FormGroup>
                <FormGroup type="static" labelwidth="col-xs-6" inputwidth="col-xs-4" label="Tax"><p className="form-control-static">{costs.total_tax}</p></FormGroup>
                <FormGroup type="static" labelwidth="col-xs-6" inputwidth="col-xs-4" label="Currency"><p className="form-control-static">{costs.currency}</p></FormGroup>
              </div>
              <div className="col-sm-6">
                <FormGroup type="static" label="Name"><p className="form-control-static">{shipping_address.name}</p></FormGroup>
                <FormGroup type="static" label="Address"><p className="form-control-static">
                  {shipping_address.street1}<br />
                  {shipping_address.street2}<br />
                  {shipping_address.city}
                </p></FormGroup>
                <FormGroup type="static" label="Postcode"><p className="form-control-static">{shipping_address.postcode}</p></FormGroup>
                <FormGroup type="static" label="Country"><p className="form-control-static">{shipping_address.country_code}</p></FormGroup>    
              </div>
            </div>

            <hr />

            <div className="row">
            {line_items &&
              <div className="row duoPanel">          
                  <h4>Items</h4>
                  <table className="table table-striped table-responsive table-bordered table-condensed">
                    <thead>
                      <tr>
                        <th>Ref</th>
                        <th className="col-sm-6">Description</th>
                        <th>Qty</th>
                        <th>Line Price</th>
                        <th>Line Tax</th>
                        <th>Line Total</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {line_items.map (row,index)=>
                        <tr key={index}>
                            <td>{row.external_id}</td>
                            <td>{row.title}</td>
                            <td>{row.quantity}</td>
                            <td><NumberFormat prefix={@currency_symbol(costs.currency)} precision={2} value={+costs.line_item_costs?[index]?.total_cost_incl_tax || 0} /></td>
                            <td><NumberFormat prefix={@currency_symbol(costs.currency)} precision={2} value={+costs.line_item_costs?[index]?.total_tax || 0} /></td>
                            <td><NumberFormat prefix={@currency_symbol(costs.currency)} precision={2} value={+costs.line_item_costs?[index]?.total_cost_incl_tax || 0} /></td>
                            <td>{row.status.name}</td>
                          </tr>
                      }
                    </tbody>
                  
                  </table>
                </div> 
              }
            </div>

          </form>
        else 
          <div>
            <p><span className="fa fa-refresh fa-spin" /> Loading from Lulu</p>
          </div>
        }
      </Modal> 

  return connect(
    (state)=>
      filters = {}
      return ({
        lulusSelected: state.lulusSelected
        luluSavedSuccess: state.luluSavedSuccess
      })
    )(LuluModal)